import Jobs from '@/api/jobs'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    company: '',
    role: '',
    locations: [],
    contract: '',
    salaryMin: '',
    salaryMax: '',
    description: '',
    currentJobId: '',
    isRemoteAvailable: false,
    rewardPercentage: 3,
    salaryCurrency: 'USD',
    status: 'pending',
    categoryId: '',
    typeId: '',
    tags: [],
    publishedAt: null
  },
  getters: {
    formData: state => {
      return {
        companyId: state.company,
        role: state.role,
        locations: state.locations,
        contract: _.lowerCase(state.contract),
        salaryMin: parseInt(state.salaryMin),
        salaryMax: parseInt(state.salaryMax),
        description: state.description,
        isRemoteAvailable: state.isRemoteAvailable,
        rewardPercentage: state.rewardPercentage,
        salaryCurrency: state.salaryCurrency,
        status: state.status,
        categoryId: state.categoryId,
        typeId: state.typeId,
        tags: state.tags
      }
    }
  },
  mutations: {
    loadWithJob (state, job) {
      state.currentJobId = job.id
      state.company = job.companyId
      state.role = job.title
      state.locations = _.zip(job.locations, job.placeIds).map(x => ({
        title: x[0],
        placeId: x[1]
      }))
      state.contract = _.capitalize(job.contract)
      state.salaryMin = job.salaryMin
      state.salaryMax = job.salaryMax
      state.description = job.description
      state.isRemoteAvailable = job.isRemoteAvailable
      state.rewardPercentage = job.rewardPercentage
      state.salaryCurrency = job.salaryCurrency ? job.salaryCurrency : 'usd'
      state.status = job.status ? job.status : 'pending'
      state.categoryId = job.categoryId
      state.typeId = job.typeId
      state.tags = job.tags
      state.publishedAt = job.publishedAt
    },
    setCompany (state, company) {
      state.company = company
    },
    setRole (state, role) {
      state.role = role
    },
    setLocations (state, locations) {
      state.locations = locations
    },
    setContract (state, contract) {
      state.contract = contract
    },
    setStatus (state, status) {
      state.status = status
    },
    setSalaryMin (state, salaryMin) {
      state.salaryMin = salaryMin
    },
    setSalaryMax (state, salaryMax) {
      state.salaryMax = salaryMax
    },
    setDescription (state, description) {
      state.description = description
    },
    setRemoteAvailable (state, remote) {
      state.isRemoteAvailable = remote
    },
    setRewardPercentage (state, reward) {
      state.rewardPercentage = reward
    },
    setSalaryCurrency (state, currency) {
      state.salaryCurrency = currency
    },
    setCategoryId (state, category) {
      state.categoryId = category
    },
    setTypeId (state, type) {
      state.typeId = type
    },
    setTags (state, tags) {
      state.tags = tags
    },
    clear (state) {
      state.company = ''
      state.role = ''
      state.locations = []
      state.contract = ''
      state.salaryMin = ''
      state.salaryMax = ''
      state.description = ''
      state.currentJobId = ''
      state.isRemoteAvailable = false
      state.rewardPercentage = 3
      state.salaryCurrency = 'usd'
      state.status = 'pending'
      state.categoryId = ''
      state.typeId = ''
      state.tags = []
    }
  },
  actions: {
    async createJob ({ commit, getters }) {
      const data = getters.formData
      const job = await Jobs.create(data)
      commit('adminJobs/addJob', job, { root: true })
    },
    async updateJob  ({ commit, state, getters }) {
      const data = getters.formData
      const jobId = state.currentJobId
      const job = await Jobs.update(jobId, data)
      commit('adminJobs/updateJob', job, { root: true })
    },
    async removeJob ({ commit, state }) {
      const jobId = state.currentJobId
      await Jobs.remove(jobId)
      commit('adminJobs/removeJob', jobId, { root: true })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/job-form.js